import styled from "styled-components";

export const Content = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    font-family: "Poppins";
    font-size: 20px;
    font-weight: 500;
  }
`;

export const BrandsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const BrandCardContainer = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);
`;

export const BrandCardBody = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
`;

export const BrandCardImage = styled.div`
  flex-shrink: 0;

  img {
    width: 72px;
    height: 72px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #eee;
  }
`;

export const BrandCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const BrandName = styled.span`
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

export const BrandSlug = styled.span`
  font-family: "Poppins";
  font-size: 13px;
  color: #6c6c6c;
`;

export const BrandInfo = styled.span`
  font-family: "Poppins";
  font-size: 13px;
  color: #6c6c6c;
`;

export const BadgesRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const Badge = styled.span`
  font-family: "Poppins";
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  color: #fff;
  background-color: ${({ color }) => color || "#6c757d"};
`;

export const BrandCardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const NameWithCopy = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CopyIcon = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #9e9e9e;
  transition: color 0.2s ease;

  &:hover {
    color: #7a7a7a;
  }
`;

export const NfceArea = styled.div`
  display: flex;
  align-items: end;
  gap: 16px;
  padding-top: 16px;
  border-top: 1px solid #ededed;
`;

export const BrandImagePreview = styled.div`
  display: flex;
  flex-direction: ${({ hasImage }) => (hasImage ? "row" : "column")};
  align-items: center;
  gap: 12px;

  img {
    width: 120px;
    height: 120px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #ddd;
  }

  label {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 120px;
    border-radius: 8px;
    border: 2px dashed #ddd;
    color: #999;
    font-family: "Poppins";
    font-size: 12px;
    text-align: center;
    transition: border-color 0.2s;

    &:hover {
      border-color: #007bff;
    }
  }

  input[type="file"] {
    display: none;
  }
`;

export const FormGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: ${({ columns }) => columns || "1fr 1fr"};
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  span {
    font-family: "Poppins";
    font-size: 14px;
    font-weight: 500;
    color: #222;
  }
`;

export const HintText = styled.p`
  font-family: "Poppins";
  font-size: 12px;
  color: #999;
  margin: -8px 0 0 0;
`;

export const CenterMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  gap: 12px;

  span {
    font-family: "Poppins";
    font-size: 14px;
    color: #6c6c6c;
  }
`;
